import React, { createContext, useContext, ReactNode } from "react";
import usePersistantStopwatch from "./usePersistantStopwatch";

interface StopwatchContextProps {
  elapsedTime: number;
  start: () => void;
  pause: () => void;
  reset: () => void;
  isPaused: boolean;
}

const StopwatchContext = createContext<StopwatchContextProps | undefined>(
  undefined
);

export const useGlobalStopwatch = () => {
  const context = useContext(StopwatchContext);
  if (!context) {
    throw new Error("useStopwatch must be used within a StopwatchProvider");
  }
  return context;
};

export const StopwatchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { elapsedTime, start, pause, reset, isPaused } =
    usePersistantStopwatch();

  return (
    <StopwatchContext.Provider
      value={{ elapsedTime, start, pause, reset, isPaused }}
    >
      {children}
    </StopwatchContext.Provider>
  );
};
